import { FC } from 'react';
import { PageContainer } from '../../components/page/PageContainer';
import { PageHeader } from '../../components/page/PageHeader';
import { PageSizer } from '../../components/page/PageSizer';
import strings from './documents.translations';
import { NavPage } from '../../components/page/Breadcrumbs';
import { SearchBar } from '../../components/file/SearchBar';
import { useIntroduction } from '../../services/graph/hooks/introduction';

export const SearchPage: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.common.pages.documents,
      to: '/documents'
    },
    {
      name: strings.common.search,
      to: `/documents/search`
    }
  ];

  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error("Could not get image data");
  }
  
  return (
    <PageContainer>
      <PageHeader
        title={strings.common.search}
        description={strings.search.emptyDesc}
        imageUrl={introduction.data.backgroundImages.searchPage}
        breadcrumbs={breadcrumbs}
      />
        <PageSizer className="py-5 flex flex-col gap-10">
          <SearchBar />
        </PageSizer>
    </PageContainer>
  );
};
